type EditDocument = {
  fileType: string;
  key: string;
  referenceData?: {
    fileKey: string;
    instanceId: string;
    key: string;
  };
  title: string;
  url: string;
  info?: {
    owner?: string;
    uploaded?: string;
    favorite?: boolean;
    folder?: string;
    sharingSettings?: any[];
  };
};

const editDocument: EditDocument = {
  fileType: "",
  key: "",
  title: "",
  url: "",
};

export type { EditDocument };

export { editDocument };
